import { Box } from '@chakra-ui/react';
import { FilterFooter } from './UiItems/FilterFooter';
import { EmployeeSize } from '@/assets/icons/filters';

export const SecondaryFilterWrapper = ({
  children,
  filterConfig = {},
  onAction = () => {},
  filterActions = () => {},
  icon = EmployeeSize,
  selected = [],
  currentlySelected = [],
  clearSearchTerm = () => {},
}) => {
  const { id: filterId, isMultiple = true } = filterConfig;

  const handleFilterAction = (actionType) => {
    if (actionType === 'reset') {
      filterActions({ type: 'clear', value: selected, key: filterId });
    } else if (actionType === 'apply') {
      filterActions({ type: 'apply', value: selected, key: filterId });
    }
    onAction();
    clearSearchTerm();
  };

  return (
    <Box>
      <Box minH="100px">{children}</Box>
      {isMultiple && (
        <FilterFooter
          selected={currentlySelected}
          onApply={() => handleFilterAction('apply')}
          onClear={() => handleFilterAction('reset')}
        />
      )}
    </Box>
  );
};
